import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import './UpdateActivity.css'

function UserActivity() {
    const [staffs, setStaffs] = useState([])

    useEffect(() => {
        axios.get('https://school-web-server-eight.vercel.app/activities')
            .then(result => {
                console.log(result.data); // ตรวจสอบข้อมูลที่ได้รับ
                setStaffs(result.data);
            })
            .catch(err => console.error('Error fetching user activities:', err));
    }, []);

    const handleDelete = async (id, imageName) => {
        try {
            // Delete the user from the backend
            await axios.delete(`https://school-web-server-eight.vercel.app/deleteactivities/${id}`);

            // If user deletion is successful, delete the associated image
            if (imageName && imageName !== "none_profile.jpg") {
                await axios.delete(`https://school-web-server-eight.vercel.app/deleteImage/${imageName}`);
            }

            // Update the local state to remove the deleted user
            // setStaffs(staffs.filter(staff => staff._id !== id));
            setStaffs((prevStaffs) => prevStaffs.filter((staff) => staff._id !== id));
        } catch (error) {
            console.error('Error deleting staff:', error);
        }
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className='activity-container'>
                    <div className='header-ac'> 
                    <h1>กิจกรรม</h1>
                    <Link to='createactivity' className='btn-add'>เพิ่มกิจกรรม</Link>
                    </div>
                    
                <table className='table'>
                            <tbody >
                                {staffs.map((staff) => (
                                    <tr className='card' key={staff._id}>
                                        <td>
                                            <img
                                                src={`https://school-web-server-eight.vercel.app/activities/${staff.image}`}
                                                alt=""
                                                style={{objectFit: 'cover' }}
                                            />
                                        </td>
                                        <td>{staff.name}</td>
                                        <td>{formatDate(staff.date)}</td>
                                        <td>{staff.link}</td>
                                        <td>
                                            <Link to={`updateactivity/${staff._id}`} className='update-info'>อัพเดทข้อมูล</Link>
                                            <button className='delete-ac' onClick={() => handleDelete(staff._id, staff.image)}>ลบทั้งหมด</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
            </div>
        </>
    )
}

export default UserActivity
